import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class SharingService {
  path:string = "sharing";

  constructor(private httpClient: HttpClient) { }

  validate(entity:any):Observable<any>{
    return this.httpClient.post(environment.baseURL + this.path+"/validate",entity);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/sharing.service.ts